import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import ReactionList from '../ReactionList';

interface LikesListModalProps {
    isOpen: boolean;
    toggle: () => void;
    entityType: string;
    entityId: string;
}

const LikesListModal: React.FC<LikesListModalProps> = ({
    isOpen,
    toggle,
    entityType,
    entityId
}) => {
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            backdrop={true} 
            scrollable={true}
            fade={false}
            className={`custom-modal-md modal-dialog-bottom modal-dialog-bottom-style`}
            modalClassName={`modal-slide-down`}
        >
            <ModalHeader toggle={toggle}>
                Reactions
            </ModalHeader>
            <ModalBody className="comment-like-modal-body">
                <ReactionList 
                    entityType={entityType} 
                    entityId={entityId} 
                />
            </ModalBody>
        </Modal>
    );
};

export default LikesListModal;